export const UPLOAD_ITEM = 'UPLOAD_ITEM'
export const UPLOAD_ITEM_SUCCESS = 'UPLOAD_ITEM_SUCCESS'

export const onLoadMerchant = payload => ({
    type: 'ON_LOAD_MERCHANT',
    payload,
})

export const onChange = payload => ({
    type: 'ON_CHANGE_MERCHANT',
    payload,
})

export const onUploadMerchant = payload => ({
    type: 'ON_UPLOAD_MERCHANT',
    payload,
})

export const onOk = () => ({
    type: 'ON_FILE_ERROR_OK',
})

export const uploadItem = (payload) => {
    return {
        type: 'UPLOAD_ITEM',
        payload
    }
}

export const uploadItemSuccess = (payload) => {
    return {
        type: 'UPLOAD_ITEM_SUCCESS',
        payload
    }
}
export const fetchItem = (payload) => {
    return {
        type: 'FETCH_UPLOAD_MERCHANT',
        payload
    }
}
export const downloadSagaItem = (payload) => {
    return {
        type: 'DOWNLOAD_SAGA_MERCHANT',
        payload
    }
}
export const deleteSagaItem = (payload) => {
    return {
        type: 'DELETE_SAGA_MERCHANT',
        payload
    }
}
export const updateSagaItem = (payload) => {
    return {
        type: 'UPDATE_SAGA_ITEM',
        payload
    }
}
export const deleteModalSagaItem = () => {
    return {
        type: 'DELETE_MODAL_SAGA_ITEM',
    }
}
export const cancelDeleteModalSagaItem = () => {
    return {
        type: 'CANCEL_DELETE_MODAL_SAGA_ITEM',
    }
}
export const beginLoadSagaItem = () => {
    return {
        type: 'BEGIN_LOAD_SAGA_ITEM',
    }
}

export const onLoadSetting = payload => ({
    type: 'ON_LOAD_SETTING',
    payload,
})

export const onSaveSetting = payload => ({
    type: 'ON_SAVE_SETTING',
    payload
})




// WEBPACK FOOTER //
// ./src/actions/settingMerchantAction.js